/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ShivaWebSecuredConfiguration } from '../shiva-web-secured-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createGrdfConnectionConfiguration } from '../fn/grdf-connection/create-grdf-connection-configuration';
import { CreateGrdfConnectionConfiguration$Params } from '../fn/grdf-connection/create-grdf-connection-configuration';
import { exportGrdfConnectionTags } from '../fn/grdf-connection/export-grdf-connection-tags';
import { ExportGrdfConnectionTags$Params } from '../fn/grdf-connection/export-grdf-connection-tags';
import { getGrdfConnectionConfigurations } from '../fn/grdf-connection/get-grdf-connection-configurations';
import { GetGrdfConnectionConfigurations$Params } from '../fn/grdf-connection/get-grdf-connection-configurations';
import { GrdfConnectionConfig } from '../models/grdf-connection-config';
import { GrdfConnectionConfigList } from '../models/grdf-connection-config-list';
import { importGrdfConnectionTags } from '../fn/grdf-connection/import-grdf-connection-tags';
import { ImportGrdfConnectionTags$Params } from '../fn/grdf-connection/import-grdf-connection-tags';
import { listGrdfConnectionConfigurations } from '../fn/grdf-connection/list-grdf-connection-configurations';
import { ListGrdfConnectionConfigurations$Params } from '../fn/grdf-connection/list-grdf-connection-configurations';
import { removeGrdfConnectionConfiguration } from '../fn/grdf-connection/remove-grdf-connection-configuration';
import { RemoveGrdfConnectionConfiguration$Params } from '../fn/grdf-connection/remove-grdf-connection-configuration';
import { updateGrdfConnectionConfiguration } from '../fn/grdf-connection/update-grdf-connection-configuration';
import { UpdateGrdfConnectionConfiguration$Params } from '../fn/grdf-connection/update-grdf-connection-configuration';


/**
 * All about the grdf connections
 */
@Injectable({ providedIn: 'root' })
export class GrdfConnectionService extends BaseService {
  constructor(config: ShivaWebSecuredConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `listGrdfConnectionConfigurations()` */
  static readonly ListGrdfConnectionConfigurationsPath = '/stations/{uid}/grdf';

  /**
   * List a station GRDF connections configurations.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listGrdfConnectionConfigurations()` instead.
   *
   * This method doesn't expect any request body.
   */
  listGrdfConnectionConfigurations$Response(params: ListGrdfConnectionConfigurations$Params, context?: HttpContext): Observable<StrictHttpResponse<GrdfConnectionConfigList>> {
    return listGrdfConnectionConfigurations(this.http, this.rootUrl, params, context);
  }

  /**
   * List a station GRDF connections configurations.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listGrdfConnectionConfigurations$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listGrdfConnectionConfigurations(params: ListGrdfConnectionConfigurations$Params, context?: HttpContext): Observable<GrdfConnectionConfigList> {
    return this.listGrdfConnectionConfigurations$Response(params, context).pipe(
      map((r: StrictHttpResponse<GrdfConnectionConfigList>): GrdfConnectionConfigList => r.body)
    );
  }

  /** Path part for operation `createGrdfConnectionConfiguration()` */
  static readonly CreateGrdfConnectionConfigurationPath = '/stations/{uid}/grdf';

  /**
   * Create a station GRDF connection configuration.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createGrdfConnectionConfiguration()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createGrdfConnectionConfiguration$Response(params: CreateGrdfConnectionConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return createGrdfConnectionConfiguration(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a station GRDF connection configuration.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createGrdfConnectionConfiguration$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createGrdfConnectionConfiguration(params: CreateGrdfConnectionConfiguration$Params, context?: HttpContext): Observable<void> {
    return this.createGrdfConnectionConfiguration$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getGrdfConnectionConfigurations()` */
  static readonly GetGrdfConnectionConfigurationsPath = '/stations/{uid}/grdf/{grdfUid}';

  /**
   * Get a station GRDF connection configuration.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getGrdfConnectionConfigurations()` instead.
   *
   * This method doesn't expect any request body.
   */
  getGrdfConnectionConfigurations$Response(params: GetGrdfConnectionConfigurations$Params, context?: HttpContext): Observable<StrictHttpResponse<GrdfConnectionConfig>> {
    return getGrdfConnectionConfigurations(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a station GRDF connection configuration.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getGrdfConnectionConfigurations$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getGrdfConnectionConfigurations(params: GetGrdfConnectionConfigurations$Params, context?: HttpContext): Observable<GrdfConnectionConfig> {
    return this.getGrdfConnectionConfigurations$Response(params, context).pipe(
      map((r: StrictHttpResponse<GrdfConnectionConfig>): GrdfConnectionConfig => r.body)
    );
  }

  /** Path part for operation `updateGrdfConnectionConfiguration()` */
  static readonly UpdateGrdfConnectionConfigurationPath = '/stations/{uid}/grdf/{grdfUid}';

  /**
   * Update a station GRDF connection configuration.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateGrdfConnectionConfiguration()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateGrdfConnectionConfiguration$Response(params: UpdateGrdfConnectionConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateGrdfConnectionConfiguration(this.http, this.rootUrl, params, context);
  }

  /**
   * Update a station GRDF connection configuration.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateGrdfConnectionConfiguration$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateGrdfConnectionConfiguration(params: UpdateGrdfConnectionConfiguration$Params, context?: HttpContext): Observable<void> {
    return this.updateGrdfConnectionConfiguration$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `removeGrdfConnectionConfiguration()` */
  static readonly RemoveGrdfConnectionConfigurationPath = '/stations/{uid}/grdf/{grdfUid}';

  /**
   * Remove the station GRDF connection configuration.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `removeGrdfConnectionConfiguration()` instead.
   *
   * This method doesn't expect any request body.
   */
  removeGrdfConnectionConfiguration$Response(params: RemoveGrdfConnectionConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return removeGrdfConnectionConfiguration(this.http, this.rootUrl, params, context);
  }

  /**
   * Remove the station GRDF connection configuration.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `removeGrdfConnectionConfiguration$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  removeGrdfConnectionConfiguration(params: RemoveGrdfConnectionConfiguration$Params, context?: HttpContext): Observable<void> {
    return this.removeGrdfConnectionConfiguration$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `exportGrdfConnectionTags()` */
  static readonly ExportGrdfConnectionTagsPath = '/stations/{uid}/grdf/configuration/{grdfUid}/export';

  /**
   * Export the tags of the GRDF connection of a station.
   *
   * Allows to export the tags of the GRDF connection of a station, via a XLS File.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportGrdfConnectionTags()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportGrdfConnectionTags$Response(params: ExportGrdfConnectionTags$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return exportGrdfConnectionTags(this.http, this.rootUrl, params, context);
  }

  /**
   * Export the tags of the GRDF connection of a station.
   *
   * Allows to export the tags of the GRDF connection of a station, via a XLS File.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportGrdfConnectionTags$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportGrdfConnectionTags(params: ExportGrdfConnectionTags$Params, context?: HttpContext): Observable<Blob> {
    return this.exportGrdfConnectionTags$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `importGrdfConnectionTags()` */
  static readonly ImportGrdfConnectionTagsPath = '/stations/{uid}/grdf/configuration/{grdfUid}/import';

  /**
   * Import and create the tags of the GRDF connection of a station.
   *
   * Allows to import and create the tags of the GRDF connection of a station, via a XLS File.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `importGrdfConnectionTags()` instead.
   *
   * This method sends `application/vnd.ms-excel` and handles request body of type `application/vnd.ms-excel`.
   */
  importGrdfConnectionTags$Response(params: ImportGrdfConnectionTags$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return importGrdfConnectionTags(this.http, this.rootUrl, params, context);
  }

  /**
   * Import and create the tags of the GRDF connection of a station.
   *
   * Allows to import and create the tags of the GRDF connection of a station, via a XLS File.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `importGrdfConnectionTags$Response()` instead.
   *
   * This method sends `application/vnd.ms-excel` and handles request body of type `application/vnd.ms-excel`.
   */
  importGrdfConnectionTags(params: ImportGrdfConnectionTags$Params, context?: HttpContext): Observable<void> {
    return this.importGrdfConnectionTags$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
